module.exports = __webpack_public_path__ + "static/media/HP.64d3c13a.png";